 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A01COVERPAGE from '@/components/001coverpage'
 import A02HALFTITLEPAGE from '@/components/002halftitlepage'
 import A03PRAISE from '@/components/003praise'
 import A04TITLEPAGE from '@/components/004titlepage'
 import A05COPYRIGHT from '@/components/005copyright'
 import A06DEDICATION from '@/components/006dedication'
 import A07TOC from '@/components/007toc'
 import A08EXCERPT from '@/components/008excerpt'
 import A09FAIRWARNING from '@/components/009fairwarning'
 import A10PART1 from '@/components/010part1'
 import A11CHAPTER1 from '@/components/011chapter1'
 import A12CHAPTER2 from '@/components/012chapter2'
 import A13PART2 from '@/components/013part2'
 import A14CHAPTER3 from '@/components/014chapter3'
 import A15CHAPTER4 from '@/components/015chapter4'
 import A16CHAPTER5 from '@/components/016chapter5'
 import A17CHAPTER6 from '@/components/017chapter6'
 import A18CHAPTER7 from '@/components/018chapter7'
 import A19CHAPTER8 from '@/components/019chapter8'
 import A20CHAPTER9 from '@/components/020chapter9'
 import A21CHAPTER10 from '@/components/021chapter10'
 import A22PART3 from '@/components/022part3'
 import A23CHAPTER11 from '@/components/023chapter11'
 import A24CHAPTER12 from '@/components/024chapter12'
 import A25CHAPTER13 from '@/components/025chapter13'
 import A26PART4 from '@/components/026part4'
 import A27CHAPTER14 from '@/components/027chapter14'
 import A28CHAPTER15 from '@/components/028chapter15'
 import A29CHAPTER16 from '@/components/029chapter16'
 import A30CHAPTER17 from '@/components/030chapter17'
 import A31CHAPTER18 from '@/components/031chapter18'
 import A32PART5 from '@/components/032part5'
 import A33CHAPTER19 from '@/components/033chapter19'
 import A34CHAPTER20 from '@/components/034chapter20'
 import A35CHAPTER21 from '@/components/035chapter21'
 import A36CHAPTER22 from '@/components/036chapter22'
 import A37CHAPTER23 from '@/components/037chapter23'
 import A38CHAPTER24 from '@/components/038chapter24'
 import A39CHAPTER25 from '@/components/039chapter25'
 import A40PART6 from '@/components/040part6'
 import A41CHAPTER26 from '@/components/041chapter26'
 import A42CHAPTER27 from '@/components/042chapter27'
 import A43CHAPTER28 from '@/components/043chapter28'
 import A44CHAPTER29 from '@/components/044chapter29'
 import A45PART7 from '@/components/045part7'
 import A46CHAPTER30 from '@/components/046chapter30'
 import A47CHAPTER31 from '@/components/047chapter31'
 import A48CHAPTER32 from '@/components/048chapter32'
 import A49NUDEREFLECTIONS from '@/components/049nudereflections'
 import A50SIDEBAR from '@/components/050sidebar'
 import A51ACKNOWLEDGMENTS from '@/components/051acknowledgments'
 import A52ABOUTTHEPUBLISHER from '@/components/052aboutthepublisher'
 import A53CONSUMERENGAGEMENT from '@/components/053consumerengagement'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/001coverpage",
 			"name" : "001coverpage",
 			"component" : A01COVERPAGE
 		},
 		{
 			"path" : "/002halftitlepage",
 			"name" : "002halftitlepage",
 			"component" : A02HALFTITLEPAGE
 		},
 		{
 			"path" : "/003praise",
 			"name" : "003praise",
 			"component" : A03PRAISE
 		},
 		{
 			"path" : "/004titlepage",
 			"name" : "004titlepage",
 			"component" : A04TITLEPAGE
 		},
 		{
 			"path" : "/005copyright",
 			"name" : "005copyright",
 			"component" : A05COPYRIGHT
 		},
 		{
 			"path" : "/006dedication",
 			"name" : "006dedication",
 			"component" : A06DEDICATION
 		},
 		{
 			"path" : "/007toc",
 			"name" : "007toc",
 			"component" : A07TOC
 		},
 		{
 			"path" : "/008excerpt",
 			"name" : "008excerpt",
 			"component" : A08EXCERPT
 		},
 		{
 			"path" : "/009fairwarning",
 			"name" : "009fairwarning",
 			"component" : A09FAIRWARNING
 		},
 		{
 			"path" : "/010part1",
 			"name" : "010part1",
 			"component" : A10PART1
 		},
 		{
 			"path" : "/011chapter1",
 			"name" : "011chapter1",
 			"component" : A11CHAPTER1
 		},
 		{
 			"path" : "/012chapter2",
 			"name" : "012chapter2",
 			"component" : A12CHAPTER2
 		},
 		{
 			"path" : "/013part2",
 			"name" : "013part2",
 			"component" : A13PART2
 		},
 		{
 			"path" : "/014chapter3",
 			"name" : "014chapter3",
 			"component" : A14CHAPTER3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js